import { render, staticRenderFns } from "./Revisions.vue?vue&type=template&id=f2ea5eca&scoped=true&"
import script from "./Revisions.vue?vue&type=script&lang=js&"
export * from "./Revisions.vue?vue&type=script&lang=js&"
import style0 from "./Revisions.vue?vue&type=style&index=0&id=f2ea5eca&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ea5eca",
  null
  
)

export default component.exports